@if ((httpError === '409')) {
<mat-error class="top-right-absolute-error-message">{{ 'mes.administration.team-profiles.dialog.alias.error.duplicate' | translate }}</mat-error>
} @if ((duplicateError)) {
<mat-error class="top-right-absolute-error-message">{{ 'mes.administration.team-profiles.dialog.configuration.error.duplicate' | translate }}</mat-error>
}

<h1 mat-dialog-title class="notification-title">
	{{ (isEdit ? 'mes.administration.team-profiles.dialog.edit-team-profile' : 'mes.administration.team-profiles.dialog.create-team-profile') | translate }} @if (isEdit) {
	<span class="info-text">({{ teamProfile.timeZoneId }})</span>
	}
</h1>

<mat-dialog-content>
	<div style="margin-top: 15px" (keydown.enter)="saveTeamProfile()">
		<form [formGroup]="form">
			<div class="input-row">
				<div class="quater-size-field inline-field">
					@if (controls['alias'].invalid && controls['alias'].touched) {
					<mat-error>{{ 'mes.administration.team-profiles.dialog.alias.error.' + getFirstValidationErrorName('form', 'alias') | translate }}</mat-error>
					}
					<mat-form-field appearance="outline" class="dialog">
						<mat-label class="mat-body-1">{{ 'mes.administration.team-profiles.dialog.alias.label' | translate }}</mat-label>
						<input maxlength="255" matInput autofocus formControlName="alias" />
					</mat-form-field>
				</div>
				<div class="three-quater-size-field inline-field">
					@if (controls['description'].invalid && controls['description'].touched) {
					<mat-error>{{ 'mes.administration.team-profiles.dialog.description.error.' + getFirstValidationErrorName('form', 'description') | translate }}</mat-error>
					}
					<mat-form-field appearance="outline" class="dialog">
						<mat-label class="mat-body-1">{{ 'mes.administration.team-profiles.dialog.description.label' | translate }}</mat-label>
						<input maxlength="255" matInput formControlName="description" />
					</mat-form-field>
				</div>
			</div>

			@if (!isEdit) {
			<app-timezone-picker #timezonePicker (timeZoneChange)="onTimeZoneChange($event)"></app-timezone-picker>
			}

			<div class="input-row">
				<div class="half-size-field inline-field">
					@if (controls['calendarId'].invalid && controls['calendarId'].touched) {
					<mat-error>{{ 'mes.administration.team-profiles.dialog.select-calendar.error.' + getFirstValidationErrorName('form', 'calendarId') | translate }}</mat-error>
					}
					<mat-form-field appearance="outline" class="dialog">
						<mat-label class="mat-body-1">{{ 'mes.administration.team-profiles.dialog.select-calendar.label' | translate }}</mat-label>
						<mat-select formControlName="calendarId">
							@for (calendar of calendars; track calendar) {
							<mat-option [value]="calendar.id">{{ calendar.alias }}</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>
			</div>
			<div class="input-row">
				<div class="half-size-field inline-field">
					@if (noConfigurationsError) {
					<mat-error>{{ 'mes.administration.team-profiles.dialog.selectconfiguration.error.missing' | translate }}</mat-error>
					}
					<mat-form-field appearance="outline" class="dialog">
						<mat-label class="mat-body-1">{{'mes.administration.team-profiles.dialog.selectconfiguration.label' | translate}}</mat-label>
						<div class="error-label mat-subtitle-2"></div>
						<mat-select #configurationSelect [(value)]="selectedConfiguration" [disabled]="configurationEditInProgress" (selectionChange)="onSelected(configurationSelect.value)">
							@for (configuration of TeamProfileConfigurations; track configuration; let i = $index) {
							<mat-option [value]="i">({{ parseDateFormat(configuration.activeDate) }}) - {{ configuration.alias }}</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>
				<div class="half-size-field inline-field">
					<button mat-icon-button aria-label="Add configuration" [disabled]="configurationEditInProgress" (click)="addConfiguration()">
						<mat-icon svgIcon="acies_add"></mat-icon>
					</button>
					@if (!configurationEditInProgress) {
					<button mat-icon-button aria-label="Edit configuration" [disabled]="!editableConfiguration" (click)="editConfiguration()">
						<mat-icon svgIcon="acies_edit"></mat-icon>
					</button>
					} @if (!configurationEditInProgress) {
					<button mat-icon-button aria-label="Remove configuration" [disabled]="!editableConfiguration" (click)="removeConfiguration()">
						<mat-icon mat-list-icon svgIcon="acies_delete"></mat-icon>
					</button>
					} @if (configurationEditInProgress) {
					<button mat-icon-button aria-label="Save configuration" [disabled]="configForm.invalid || workTimeError || breakTimeError" (click)="saveConfiguration()">
						<mat-icon svgIcon="acies_true"></mat-icon>
					</button>
					} @if (configurationEditInProgress) {
					<button mat-icon-button aria-label="Cancel configuration edit" (click)="cancelConfiguration()">
						<mat-icon mat-list-icon svgIcon="acies_false"></mat-icon>
					</button>
					}
				</div>
			</div>
			<form [formGroup]="configForm">
				<div class="input-row">
					<div class="half-size-field inline-field">
						<div class="half-size-field inline-field">
							@if (configControls['activeDate'].invalid && configControls['activeDate'].touched) {
							<mat-error>{{ 'mes.administration.team-profiles.dialog.active-date.error.' + getFirstValidationErrorName('configForm', 'activeDate') | translate }}</mat-error>
							}
							<mat-form-field appearance="outline" class="dialog">
								<mat-label class="mat-body-1">{{'mes.administration.team-profiles.dialog.active-date.label' | translate}}</mat-label>
								<input matInput readonly [matDatepicker]="picker" [readonly]="!configurationEditInProgress" [placeholder]="'mes.administration.team-profiles.dialog.active-date.placeholder' | translate" formControlName="activeDate" />
								<mat-datepicker-toggle matIconSuffix [for]="picker" [disabled]="!configurationEditInProgress"></mat-datepicker-toggle>
								<mat-datepicker #picker></mat-datepicker>
							</mat-form-field>
						</div>
						<div class="half-size-field inline-field">
							@if (configControls['roundingTime'].invalid && configControls['roundingTime'].touched) {
							<mat-error>{{ 'mes.administration.team-profiles.dialog.rounding-time.error.' + getFirstValidationErrorName('configForm', 'roundingTime') | translate }}</mat-error>
							}
							<mat-form-field appearance="outline" class="dialog">
								<mat-label class="mat-body-1">{{'mes.administration.team-profiles.dialog.rounding-time.label' | translate}}</mat-label>
								<input #roundingTimeInput type="number" matInput [readonly]="!configurationEditInProgress" (blur)="roundingStartChanged($event)" [placeholder]="'mes.administration.team-profiles.dialog.rounding-time.placeholder' | translate" formControlName="roundingTime" />
							</mat-form-field>
						</div>
					</div>
					<div class="half-size-field inline-field">
						<div class="half-size-field inline-field">
							@if (configControls['endRoundingTime'].invalid && configControls['endRoundingTime'].touched) {
							<mat-error>{{ 'mes.administration.team-profiles.dialog.end-rounding-time.error.' + getFirstValidationErrorName('configForm', 'endRoundingTime') | translate }}</mat-error>
							}
							<mat-form-field appearance="outline" class="dialog">
								<mat-label class="mat-body-1">{{'mes.administration.team-profiles.dialog.end-rounding-time.label' | translate}}</mat-label>
								<input type="number" matInput [readonly]="!configurationEditInProgress" [placeholder]="'mes.administration.team-profiles.dialog.end-rounding-time.placeholder' | translate" formControlName="endRoundingTime" />
							</mat-form-field>
						</div>
						<div class="half-size-field inline-field">
							@if (configControls['configAlias'].invalid && configControls['configAlias'].touched) {
							<mat-error>{{ 'mes.administration.team-profiles.dialog.config-alias.error.' + getFirstValidationErrorName('configForm', 'configAlias') | translate }}</mat-error>
							}
							<mat-form-field appearance="outline" class="dialog">
								<mat-label class="mat-body-1">{{'mes.administration.team-profiles.dialog.config-alias.label' | translate}}</mat-label>
								<input type="text" matInput [readonly]="!configurationEditInProgress" autofocus [placeholder]="'mes.administration.team-profiles.dialog.config-alias.placeholder' | translate" formControlName="configAlias" />
							</mat-form-field>
						</div>
					</div>
				</div>
			</form>
			<mat-accordion>
				@for (day of daysInWeek; track day) {
				<mat-expansion-panel class="dayRow" id="{{'day-' + day.dayName.toLowerCase()}}">
					<mat-expansion-panel-header>
						<mat-panel-title>{{ 'mes.administration.team-profiles.dialog.week-days.' + day.dayName | translate }}</mat-panel-title>
						<mat-panel-description>
							<mat-checkbox labelPosition="before" [checked]="day.isWorkDay" [disabled]="!configurationEditInProgress" (click)="stopPropagation($event)" (change)="toggleIsWorkDay($event.checked, day)">{{'mes.administration.team-profiles.dialog.is-work-day.label' | translate}}</mat-checkbox>
							<input matInput type="time" class="workday-start-time" [ngClass]="{'worktime-error': day.startTimeError}" [readonly]="!configurationEditInProgress" (click)="stopPropagation($event)" (change)="changeDayStartTime($event, day)" />
							<input matInput type="time" class="workday-end-time" [ngClass]="{'worktime-error': day.endTimeError}" [readonly]="!configurationEditInProgress" (click)="stopPropagation($event)" (change)="changeDayEndTime($event, day)" />
							<span class="vww-label">VUA</span>
							<input matInput type="time" class="workday-vww-start-time" [ngClass]="{'worktime-error': day.vwwStartTimeError}" [readonly]="!configurationEditInProgress" (click)="stopPropagation($event)" (change)="changeDayVwwStartTime($event, day)" />
							<input matInput type="time" class="workday-vww-end-time" [ngClass]="{'worktime-error': day.vwwEndTimeError}" [readonly]="!configurationEditInProgress" (click)="stopPropagation($event)" (change)="changeDayVwwEndTime($event, day)" />
						</mat-panel-description>
					</mat-expansion-panel-header>
					<table mat-table [dataSource]="day.breaks">
						<ng-container matColumnDef="break-start">
							<th mat-header-cell *matHeaderCellDef>
								<input matInput type="time" class="input-break-start" [value]="day.breakStart" (change)="changeBreakStartTime($event, day)" [readonly]="!configurationEditInProgress" />
								{{ 'mes.administration.team-profiles.dialog.break-start' | translate }}
							</th>
							<td mat-cell *matCellDef="let break; let i = index">
								<input matInput [value]="break.startTime" type="time" readonly />
							</td>
						</ng-container>
						<ng-container matColumnDef="break-end">
							<th mat-header-cell *matHeaderCellDef>
								<input matInput type="time" class="input-break-end" [value]="day.breakEnd" (change)="changeBreakEndTime($event, day)" [readonly]="!configurationEditInProgress" />
								{{ 'mes.administration.team-profiles.dialog.break-end' | translate }}
							</th>
							<td mat-cell *matCellDef="let break; let i = index">
								<input matInput [value]="break.endTime" type="time" readonly />
							</td>
						</ng-container>
						<ng-container matColumnDef="remove-break">
							<th mat-header-cell *matHeaderCellDef>
								<button mat-icon-button aria-label="Add break" (click)="addBreak(day)" [disabled]="!configurationEditInProgress || day.breakError ">
									<mat-icon svgIcon="acies_add"></mat-icon>
								</button>
							</th>
							<td mat-cell *matCellDef="let i = index">
								<button mat-icon-button aria-label="Remove break" (click)="removeBreak(i, day)" [disabled]="!configurationEditInProgress">
									<mat-icon mat-list-icon svgIcon="acies_delete"></mat-icon>
								</button>
							</td>
						</ng-container>
						<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
						<tr mat-row></tr>
						<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
					</table>
				</mat-expansion-panel>
				}
			</mat-accordion>
		</form>
	</div>
</mat-dialog-content>

<div mat-dialog-actions align="end">
	<button appPreventDoubleClick mat-flat-button color="primary" cdkFocusInitial (throttledClick)="saveTeamProfile()" [disabled]="showError || form.invalid || configurationEditInProgress || noConfigurationsError">{{ 'mes.administration.team-profiles.dialog.okbtn' | translate }}</button>
	<button mat-stroked-button (click)="onNoClick()" class="button-border-color">{{ 'mes.administration.team-profiles.dialog.cancelbtn' | translate }}</button>
</div>
